import * as i0 from '@angular/core';
import { PLATFORM_ID, Injectable, Inject, NgModule } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i2 from '@adeo/ngx-kozikaza-api';
import { BaseService, KOZIKAZA_API_OPTIONS, createSubResourceObservable, ProfessionalParticularService, ProfessionalService, createSubResourceObservables } from '@adeo/ngx-kozikaza-api';
import * as i1 from '@angular/common/http';
import { ProfessionalServiceService, ProfessionalServiceTypeService } from '@adeo/ngx-kozikaza-api/pro/service';

var ProfessionalActivatedCouponSubResource;
(function (ProfessionalActivatedCouponSubResource) {
    ProfessionalActivatedCouponSubResource.Coupon = 'coupon';
    ProfessionalActivatedCouponSubResource.Owner = 'owner';
})(ProfessionalActivatedCouponSubResource || (ProfessionalActivatedCouponSubResource = {}));

var ProfessionalCoachingRequestSubResource;
(function (ProfessionalCoachingRequestSubResource) {
    ProfessionalCoachingRequestSubResource.Coach = 'coach';
    ProfessionalCoachingRequestSubResource.Customer = 'customer';
    ProfessionalCoachingRequestSubResource.Types = 'types';
    ProfessionalCoachingRequestSubResource.ActivatedCoupon = 'activatedCoupon';
})(ProfessionalCoachingRequestSubResource || (ProfessionalCoachingRequestSubResource = {}));

var ProfessionalCoachingRequestHistoryEntrySubResource;
(function (ProfessionalCoachingRequestHistoryEntrySubResource) {
    ProfessionalCoachingRequestHistoryEntrySubResource.CoachingRequest = 'coachingRequest';
})(ProfessionalCoachingRequestHistoryEntrySubResource || (ProfessionalCoachingRequestHistoryEntrySubResource = {}));

var ProfessionalCouponSalesProvider;
(function (ProfessionalCouponSalesProvider) {
    ProfessionalCouponSalesProvider["shopify"] = "shopify";
    ProfessionalCouponSalesProvider["lmfr"] = "leroy_merlin_france";
    ProfessionalCouponSalesProvider["zdfr"] = "zodio_france";
})(ProfessionalCouponSalesProvider || (ProfessionalCouponSalesProvider = {}));

var ProfessionalCouponType;
(function (ProfessionalCouponType) {
    ProfessionalCouponType["digital"] = "digital";
    ProfessionalCouponType["gift"] = "gift";
    ProfessionalCouponType["physical"] = "physical";
})(ProfessionalCouponType || (ProfessionalCouponType = {}));

class ProfessionalCouponsService extends BaseService {
    platformId;
    injector;
    static endpoint = '/professionals/coupons';
    static endpointPrefix = '/professionals';
    static endpointSuffix = '/coupons';
    getWebServiceName() {
        return 'ProfessionalCouponWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    postProfessionalCoupons(professionalCoupon, options) {
        return this.post(ProfessionalCouponsService.endpoint, professionalCoupon, options);
    }
    getProfessionalCoupons(subResources, options) {
        return this.getResources(ProfessionalCouponsService.endpoint, subResources, options);
    }
    /*    getProfessionalCouponsNavigator(
            subResources?: ProfessionalCouponSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<ProfessionalCoupon>> {
            return this.getProfessionalCoupons(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                )
                ;
        }*/
    getProfessionalCoupon(professionalCoupon, subResources, options) {
        return this.getResource(ProfessionalCouponsService.endpointPrefix +
            (typeof professionalCoupon === 'string' ? professionalCoupon : professionalCoupon['@id']), subResources, options);
    }
    putProfessionalCoupon(professionalCoupon, options) {
        return this.updateResource(ProfessionalCouponsService.endpointPrefix +
            (typeof professionalCoupon === 'string' ? professionalCoupon : professionalCoupon['@id']), professionalCoupon, options);
    }
    deleteProfessionalCoupon(professionalCoupon, options) {
        return this.delete(ProfessionalCouponsService.endpointPrefix +
            (typeof professionalCoupon === 'string' ? professionalCoupon : professionalCoupon['@id']), options);
    }
    getSubResourceObservable(professionalCoupon, subResourceRequest, options) {
        return undefined;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalCouponsService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalCouponsService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalCouponsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

class ProfessionalActivatedCouponsService extends BaseService {
    platformId;
    injector;
    static endpoint = '/professionals/activated_coupons';
    static endpointPrefix = '/professionals';
    static endpointSuffix = '/activated_coupons';
    getWebServiceName() {
        return 'ProfessionalActivatedCouponWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    postProfessionalActivatedCoupons(professionalActivatedCoupon, options) {
        return this.post(ProfessionalActivatedCouponsService.endpoint, professionalActivatedCoupon, options);
    }
    getProfessionalActivatedCoupons(subResources, options) {
        return this.getResources(ProfessionalActivatedCouponsService.endpoint, subResources, options);
    }
    /*    getProfessionalActivatedCouponsNavigator(
            subResources?: ProfessionalActivatedCouponSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<ProfessionalActivatedCoupon>> {
            return this.getProfessionalActivatedCoupons(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                )
                ;
        }*/
    getProfessionalActivatedCoupon(professionalActivatedCoupon, subResources, options) {
        return this.getResource(ProfessionalActivatedCouponsService.endpointPrefix +
            (typeof professionalActivatedCoupon === 'string' ? professionalActivatedCoupon : professionalActivatedCoupon['@id']), subResources, options);
    }
    putProfessionalActivatedCoupon(professionalActivatedCoupon, options) {
        return this.updateResource(ProfessionalActivatedCouponsService.endpointPrefix +
            (typeof professionalActivatedCoupon === 'string' ? professionalActivatedCoupon : professionalActivatedCoupon['@id']), professionalActivatedCoupon, options);
    }
    getSubResourceObservable(professionalActivatedCoupon, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case ProfessionalActivatedCouponSubResource.Owner:
                if (professionalActivatedCoupon.owner) {
                    const ownerId = typeof professionalActivatedCoupon.owner === 'string'
                        ? professionalActivatedCoupon.owner : professionalActivatedCoupon.owner['@id'];
                    const ownerIsParticular = ownerId.includes(ProfessionalParticularService.endpointParticularsSuffix);
                    // check if particular or professional (by checking if professionalActivatedCoupon.owner
                    // contains /professionals or /particulars)
                    return createSubResourceObservable(ownerIsParticular
                        ? this.injector.get(ProfessionalService).getProfessional(ownerId, subResourceRequest[1], options)
                        : this.injector.get(ProfessionalParticularService).getProfessionalParticular(ownerId, subResourceRequest[1], options), options)
                        .pipe(map(owner => {
                        professionalActivatedCoupon.owner = owner;
                        return professionalActivatedCoupon;
                    }));
                }
                return undefined;
            case ProfessionalActivatedCouponSubResource.Coupon:
                if (professionalActivatedCoupon.coupon) {
                    return createSubResourceObservable(this.injector.get(ProfessionalCouponsService).getProfessionalCoupon(professionalActivatedCoupon.coupon, subResourceRequest[1], options), options)
                        .pipe(map(coupon => {
                        professionalActivatedCoupon.coupon = coupon;
                        return professionalActivatedCoupon;
                    }));
                }
                return undefined;
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalActivatedCouponsService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalActivatedCouponsService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalActivatedCouponsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

class ProfessionalCoachingRequestService extends BaseService {
    platformId;
    injector;
    static endpoint = '/professionals/coaching_requests';
    static endpointPrefix = '/professionals';
    static endpointSuffix = '/coaching_requests';
    getWebServiceName() {
        return 'ProfessionalCoachingRequestWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    postProfessionalCoachingRequests(professionalCoachingRequest, options) {
        return this.post(ProfessionalCoachingRequestService.endpoint, professionalCoachingRequest, options);
    }
    getProfessionalCoachingRequests(subResources, options) {
        return this.getResources(ProfessionalCoachingRequestService.endpoint, subResources, options);
    }
    /*    getProfessionalCoachingRequestsNavigator(
            subResources?: ProfessionalCoachingRequestSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<ProfessionalCoachingRequest>> {
            return this.getProfessionalCoachingRequests(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                );
        }*/
    getProfessionalCoachingRequest(professionalCoachingRequest, subResources, options) {
        return this.getResource(ProfessionalCoachingRequestService.endpointPrefix +
            (typeof professionalCoachingRequest === 'string' ? professionalCoachingRequest : professionalCoachingRequest['@id']), subResources, options);
    }
    getProfessionalCoachingRequestsByProfessional(professional, subResources, options) {
        return this.getResources(`${ProfessionalServiceService.endpointPrefix}` +
            // eslint-disable-next-line max-len
            `${typeof professional === 'string' ? professional : professional['@id']}${ProfessionalServiceService.endpointServiceSuffix}`, subResources, options);
    }
    /*    getProfessionalCoachingRequestsByProfessionalNavigator(
            professional: Partial<Professional> | string,
            subResources?: ProfessionalCoachingRequestSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<ProfessionalCoachingRequest>> {
            return this.getProfessionalCoachingRequestsByProfessional(professional, subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                );
        }*/
    putProfessionalCoachingRequest(professionalCoachingRequest, options) {
        return this.updateResource(ProfessionalCoachingRequestService.endpointPrefix +
            (typeof professionalCoachingRequest === 'string' ? professionalCoachingRequest : professionalCoachingRequest['@id']), professionalCoachingRequest, options);
    }
    professionalCoachingRequestTransition(professionalCoachingRequest, transition, transitionPayload, options) {
        return this.post(ProfessionalCoachingRequestService.endpointPrefix +
            (typeof professionalCoachingRequest === 'string' ? professionalCoachingRequest : professionalCoachingRequest['@id']) +
            '/' + transition, transitionPayload || {}, options);
    }
    deleteProfessionalCoachingRequest(professionalCoachingRequest, options) {
        return this.delete(ProfessionalCoachingRequestService.endpointPrefix +
            (typeof professionalCoachingRequest === 'string' ? professionalCoachingRequest : professionalCoachingRequest['@id']), options);
    }
    getSubResourceObservable(professionalCoachingRequest, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case ProfessionalCoachingRequestSubResource.Customer:
                if (professionalCoachingRequest.customer) {
                    const ownerId = typeof professionalCoachingRequest.customer === 'string'
                        ? professionalCoachingRequest.customer : professionalCoachingRequest.customer['@id'];
                    const ownerIsParticular = ownerId.includes(ProfessionalParticularService.endpointParticularsSuffix);
                    // check if particular or professional (by checking if professionalCoachingRequest.owner
                    // contains /professionals or /particulars)
                    return createSubResourceObservable(ownerIsParticular
                        ? this.injector.get(ProfessionalService).getProfessional(ownerId, subResourceRequest[1], options)
                        : this.injector.get(ProfessionalParticularService).getProfessionalParticular(ownerId, subResourceRequest[1], options), options)
                        .pipe(map(owner => {
                        professionalCoachingRequest.customer = owner;
                        return professionalCoachingRequest;
                    }));
                }
                return undefined;
            case ProfessionalCoachingRequestSubResource.Coach:
                if (professionalCoachingRequest.coach) {
                    return createSubResourceObservable(this.injector.get(ProfessionalService).getProfessional(professionalCoachingRequest.coach, subResourceRequest[1], options), options)
                        .pipe(map(professional => {
                        professionalCoachingRequest.coach = professional;
                        return professionalCoachingRequest;
                    }));
                }
                return undefined;
            case ProfessionalCoachingRequestSubResource.ActivatedCoupon:
                if (professionalCoachingRequest.activatedCoupon) {
                    return createSubResourceObservable(this.injector.get(ProfessionalActivatedCouponsService).getProfessionalActivatedCoupon(professionalCoachingRequest.activatedCoupon, subResourceRequest[1], options), options)
                        .pipe(map(activatedCoupon => {
                        professionalCoachingRequest.activatedCoupon = activatedCoupon;
                        return professionalCoachingRequest;
                    }));
                }
                return undefined;
            case ProfessionalCoachingRequestSubResource.Types:
                if (professionalCoachingRequest.types && professionalCoachingRequest.types.length > 0) {
                    const typesObservable = [];
                    professionalCoachingRequest.types.map(type => {
                        typesObservable.push(this.injector.get(ProfessionalServiceTypeService).getProfessionalServiceType(type, subResourceRequest[1], options));
                    });
                    return createSubResourceObservables(typesObservable, options, professionalCoachingRequest.types)
                        .pipe(map(types => {
                        professionalCoachingRequest.types = types;
                        return professionalCoachingRequest;
                    }));
                }
                return undefined;
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalCoachingRequestService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalCoachingRequestService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalCoachingRequestService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

class ProfessionalCoachingRequestHistoryEntryService extends BaseService {
    platformId;
    injector;
    static endpoint = '/professionals/coaching_request_history_entries';
    static endpointPrefix = '/coaching_request_history_entries';
    getWebServiceName() {
        return 'ProfessionalCoachingRequestHistoryWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    getProfessionalCoachingRequestHistoryEntries(subResources, options) {
        return this.getResources(ProfessionalCoachingRequestHistoryEntryService.endpoint, subResources, options);
    }
    /*  getProfessionalCoachingRequestHistoryEntriesNavigator(
        subResources?: ProfessionalCoachingRequestHistoryEntrySubResources,
        options?: WebServiceOptions,
      ): Observable<HydraCollectionNavigator<ProfessionalCoachingRequestHistoryEntry>> {
        return this.getProfessionalCoachingRequestHistoryEntries(subResources, options)
          .pipe(
            map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
          )
          ;
      }*/
    getProfessionalCoachingRequestHistoryEntry(professionalCoachingRequestHistoryEntry, subResources, options) {
        return this.getResource(ProfessionalCoachingRequestHistoryEntryService.endpointPrefix +
            (typeof professionalCoachingRequestHistoryEntry === 'string' ?
                professionalCoachingRequestHistoryEntry :
                professionalCoachingRequestHistoryEntry['@id']), subResources, options);
    }
    getSubResourceObservable(professionalCoachingRequestHistoryEntry, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case ProfessionalCoachingRequestHistoryEntrySubResource.CoachingRequest:
                if (professionalCoachingRequestHistoryEntry.coachingRequest) {
                    const coachingRequest = typeof professionalCoachingRequestHistoryEntry.coachingRequest === 'string'
                        ? professionalCoachingRequestHistoryEntry.coachingRequest : professionalCoachingRequestHistoryEntry.coachingRequest['@id'];
                    return createSubResourceObservable(this.injector.get(ProfessionalCoachingRequestService).getProfessionalCoachingRequest(coachingRequest, subResourceRequest[1], options), options)
                        .pipe(map(cr => {
                        professionalCoachingRequestHistoryEntry.coachingRequest = cr;
                        return professionalCoachingRequestHistoryEntry;
                    }));
                }
                return undefined;
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalCoachingRequestHistoryEntryService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalCoachingRequestHistoryEntryService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalCoachingRequestHistoryEntryService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

class ProfessionalCoachingRequestWD {
    transitions;
    constructor() {
    }
    getState(resource) {
        return resource.state;
    }
}
class ProfessionalCoachingRequestWDAdmin extends ProfessionalCoachingRequestWD {
    constructor() {
        super();
    }
    getTree() {
        const tree = [
            {
                name: 'validate',
                from: ['dispute'],
                to: 'completed',
                actionType: 'success',
            },
            {
                name: 'cancel',
                from: ['dispute'],
                to: 'cancelled',
                actionType: 'refusal',
            },
            {
                name: 'cancel_dispute',
                from: ['dispute'],
                to: 'in_progress',
                actionType: 'success',
            },
            {
                name: 'validate',
                from: ['finished'],
                to: 'completed',
                actionType: 'success',
            },
        ];
        return tree;
    }
}
class ProfessionalCoachingRequestWDCustomer extends ProfessionalCoachingRequestWD {
    constructor() {
        super();
    }
    getTree() {
        const tree = [
            // {
            //     name: 'pre_creation_update',
            //     from: ['pre_created'],
            //     to: 'pre_created',
            //     actionType: 'success',
            // },
            {
                name: 'accept',
                from: ['pre_created'],
                to: 'accepted',
                actionType: 'success',
            },
            {
                name: 'cancel',
                from: ['created', /*'waiting_payment_confirmation',*/ 'accepted'],
                to: 'cancelled',
                actionType: 'refusal',
            },
            {
                name: 'pay_internal',
                from: ['accepted'],
                to: 'in_progress',
                actionType: 'success',
            },
            // {
            //     name: 'pay_external',
            //     from: ['accepted'],
            //     to: 'waiting_payment_confirmation',
            //     actionType: 'success',
            // },
            {
                name: 'declare_dispute',
                from: ['in_progress', 'finished'],
                to: 'dispute',
                actionType: 'refusal',
            },
            {
                name: 'validate',
                from: ['finished'],
                to: 'completed',
                actionType: 'success',
            },
            {
                name: 'decline',
                from: ['pre_created'],
                to: 'declined',
                actionType: 'refusal',
            },
        ];
        return tree;
    }
}
class ProfessionalCoachingRequestWDCoach extends ProfessionalCoachingRequestWD {
    constructor() {
        super();
    }
    getTree() {
        const tree = [
            // {
            //     name: 'pre_creation_update',
            //     from: ['pre_created'],
            //     to: 'pre_created',
            //     actionType: 'success',
            // },
            {
                name: 'accept',
                from: ['created'],
                to: 'accepted',
                actionType: 'success',
            },
            {
                name: 'cancel',
                from: [/*'waiting_payment_confirmation',*/ 'accepted', 'in_progress'],
                to: 'cancelled',
                actionType: 'refusal',
            },
            {
                name: 'decline',
                from: ['created'],
                to: 'declined',
                actionType: 'refusal',
            },
            {
                name: 'finish',
                from: ['in_progress'],
                to: 'finished',
                actionType: 'success',
            },
            // {
            //     name: 'confirm_payment',
            //     from: ['waiting_payment_confirmation'],
            //     to: 'in_progress',
            //     actionType: 'success',
            // }
        ];
        return tree;
    }
}

// import { ProServiceApiModule } from '../service';
const WEB_SERVICES = [
    ProfessionalActivatedCouponsService,
    ProfessionalCoachingRequestService,
    ProfessionalCoachingRequestHistoryEntryService,
    ProfessionalCouponsService,
];
class ProCoachingRequestApiModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProCoachingRequestApiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.8", ngImport: i0, type: ProCoachingRequestApiModule });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProCoachingRequestApiModule, providers: [
            ...WEB_SERVICES,
        ] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProCoachingRequestApiModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                    // TODO : test if necessary or only for ProfessionalServiceService.endpointPrefix in coaching request service...
                    // ProServiceApiModule,
                    ],
                    providers: [
                        ...WEB_SERVICES,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ProCoachingRequestApiModule, ProfessionalActivatedCouponSubResource, ProfessionalActivatedCouponsService, ProfessionalCoachingRequestHistoryEntryService, ProfessionalCoachingRequestHistoryEntrySubResource, ProfessionalCoachingRequestService, ProfessionalCoachingRequestSubResource, ProfessionalCoachingRequestWD, ProfessionalCoachingRequestWDAdmin, ProfessionalCoachingRequestWDCoach, ProfessionalCoachingRequestWDCustomer, ProfessionalCouponSalesProvider, ProfessionalCouponType, ProfessionalCouponsService };
